//  设备巡检计划
import request from '@/utils/httpRequest'

export function queryById (id) {
    return request({
        url: '/equipment/wuyeEquipmentPlan/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/equipment/wuyeEquipmentPlan/startFlow',
        method: 'post',
        data: params
    })
}